import React from 'react';
import LoadingSpinner from '../LoadingSpinner';

interface SectionLoadingProps {
  isLoading: boolean;
  children: React.ReactNode;
  className?: string;
  loadingText?: string;
  minHeight?: string;
}

const SectionLoading: React.FC<SectionLoadingProps> = ({ 
  isLoading, 
  children, 
  className = '',
  loadingText = 'Loading...',
  minHeight = 'min-h-[60px]'
}) => {
  if (isLoading) {
    return (
      <div className={`flex items-center justify-center ${minHeight} ${className}`}>
        <div className="flex flex-col items-center space-y-2">
          <LoadingSpinner size="md" color="primary" />
          <p className="text-sm text-gray-500">{loadingText}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default SectionLoading;